<template>
    <div class="ui-body">
        <!-- 02.01.主体容器 Start -->
        <!-- 02.01.主体容器 End -->

        <!-- 01.主体容器 - 头部 Start -->
        <div class="ui-container-header">
            <!-- 01.01.主体容器 - 头部 - 标题 Start -->
            <h3 class="ui-container-header-title"><i class="ion-ios-arrow-forward"></i>{{ this.$route.meta.title }}</h3>
            <!-- 01.01.主体容器 - 头部 - 标题 End -->
            <!-- 01.02.主体容器 - 头部 - 副标题 Start -->
            <p class="ui-container-header-subtitle">{{ this.$route.meta.description }}</p>
            <!-- 01.02.主体容器 - 头部 - 副标题 End -->
        </div>
        <!-- 01.主体容器 - 头部 End -->

        <!-- 02.主体容器 - 内容 Start -->
        <div class="ui-container-all">
            <div class="ui-content ui-page-user">
                <el-tabs v-model="tabsActive">
                    <el-tab-pane label="基础设置" name="one">
                        <el-form class="ui-user-form" ref="formContent" :model="formContent" :label-width="formWidth" :label-position="formPosition" :rules="formRules">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="用户姓名" prop="title">
                                        <el-input v-model="formContent.title" placeholder="请输入用户姓名"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-upload class="ui-avatar" :action="this.$api_url+'/api/upload/images/'" :headers="{'token':token}" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                                        <img v-if="avatarUpload" :src="avatarUpload" class="avatar_images">
                                        <el-empty description="请选择头像" v-else></el-empty>
                                    </el-upload>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="用户名">
                                        <el-input v-model="formContent.user_name" placeholder="请输入用户名" :disabled="true"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="联系电话">
                                        <el-input v-model="formContent.phone" placeholder="请输入联系电话"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="电子邮箱">
                                        <el-input v-model="formContent.mail" placeholder="请输入电子邮箱"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="用户说明">
                                        <el-input type="textarea" v-model="formContent.content" rows="10" placeholder="请输入用户说明"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="22">
                                    <el-button type="primary" plain @click="patchUserContent"><i
                                            class="ion-ios-checkmark-circle"></i>更新信息
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="安全设置" name="two">
                        <ul class="ui-config-list">
                            <li>
                                <span>账户密码</span>
                                <p>修改用户密码，使帐号更安全</p>
                                <el-link :underline="false" @click="passDialog = true">修改</el-link>
                            </li>
                            <li>
                                <span>绑定手机</span>
                                <p>已绑定手机号：+86185****0000</p>
                                <el-link :underline="false">修改</el-link>
                            </li>
                            <li>
                                <span>密保问题</span>
                                <p>未设置密保问题，密保问题可有效保护账户安全</p>
                                <el-link :underline="false">修改</el-link>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="消息通知" name="three">
                        <ul class="ui-config-list">
                            <li>
                                <span>系统通知</span>
                                <p>平台向您发消息时的通知</p>
                                <el-switch v-model="system_state_switch"
                                           @change="changeSystemState($event)"></el-switch>
                            </li>
                            <li>
                                <span>审批通知</span>
                                <p>平台向您发审批时的通知</p>
                                <el-switch v-model="approval_state_switch"
                                           @change="changeApprovalState($event)"></el-switch>
                            </li>
                            <li>
                                <span>IM消息</span>
                                <p>IM平台向您发私人消息时的通知</p>
                                <el-switch v-model="im_state_switch" @change="changeImState($event)"></el-switch>
                            </li>
                            <li>
                                <span>短信设置</span>
                                <p>平台是否默认向您绑定的手机号，发送相关消息时的通知</p>
                                <el-switch v-model="message_state_switch"
                                           @change="changeMessageState($event)"></el-switch>
                            </li>
                            <li>
                                <span>邮件设置</span>
                                <p>平台是否默认向您绑定的电子邮箱，发送相关消息时的通知</p>
                                <el-switch v-model="mail_state_switch"
                                           @change="changeMailState($event)"></el-switch>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="主题设置" name="four">
                        <ul class="ui-config-list">
                            <li>
                                <span>夜间主题设置</span>
                                <p>是否开启夜间主题？</p>
                                <el-switch v-model="night_theme_switch"
                                           @change="changeThemeSwitch($event)"></el-switch>
                            </li>
                            <li>
                                <span>切换主题设置</span>
                                <p>是否根据时间切换主题？</p>
                                <el-switch v-model="automatic_theme_switch"
                                           @change="changeAutomaticTheme($event)"></el-switch>
                            </li>
                            <li>
                                <span>折叠按钮设置</span>
                                <p>是否显示折叠侧边栏按钮？</p>
                                <el-switch v-model="side_button_switch"
                                           @change="changeCollapseBtn($event)"></el-switch>
                            </li>
                            <li>
                                <span>侧边栏手风琴设置</span>
                                <p>是否开启侧边栏手风琴模式？</p>
                                <el-switch v-model="side_accordion_switch"
                                           @change="changeSideOpened($event)"></el-switch>
                            </li>
                            <li>
                                <span>多页签设置</span>
                                <p>是否开启多页签？</p>
                                <el-switch v-model="tabs_multiple_switch"
                                           @change="changeTabsState($event)"></el-switch>
                            </li>
                        </ul>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!-- 02.主体容器 - 内容 End -->
        <!-- 03.内容页 Content Start -->
        <el-dialog title="修改用户密码" :visible.sync="passDialog" width="30%">
            <el-form class="ui-pass-form" ref="passContent" :model="passContent" :label-position="passPosition" :rules="passRules">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="原密码" prop="used_pass_word">
                            <el-input v-model="passContent.used_pass_word" placeholder="请输入原密码" show-password></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="新密码" prop="new_pass_word">
                            <el-input v-model="passContent.new_pass_word" placeholder="请输入新密码" show-password></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="重复密码" prop="repeat_pass_word">
                            <el-input v-model="passContent.repeat_pass_word" placeholder="请输入重复密码" show-password></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="patchPassWord"><i class="ion-ios-checkmark-circle"></i>修改密码</el-button>
                    </el-col>
                    <el-col :span="12">
                        <el-button @click="resetPassWord" icon="ion-ios-repeat">重置</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <!-- 03.内容页 Content End -->
    </div>
</template>

<script>
    export default {
        name: "user_config",
        data() {
            // 自定义密码验证
            let new_pass_verification = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入新密码'));
                } else {
                    callback();
                }
            };

            let repeat_pass_verification = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入重复密码'));
                } else if (value !== this.passContent.new_pass_word) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };

            return {
                // 00.Token
                token: localStorage.getItem('Token'),
                // 02.Tabs 配置 ------------------------------------------------
                // 02.01.Tabs 选中
                tabsActive: 'one',
                // 02.02.Tabs 位置
                tabsPosition: 'right',
                // 03.Dialog 弹出框 ------------------------------------------------
                // 03.01.账户密码
                dialogPassWord: false,
                // 03.02.绑定手机
                dialogPhone: false,
                // 03.03.密保问题
                dialogSecretGuard: false,
                // 04.Switch 开关配置 ------------------------------------------------
                // 04.01.消息通知
                // 04.01.01.系统通知
                system_state_switch: false,
                // 04.01.02.审批通知
                approval_state_switch: false,
                // 04.01.03.IM消息
                im_state_switch: false,
                // 04.01.04.短信设置
                message_state_switch: false,
                // 04.01.05.邮件设置
                mail_state_switch: false,
                // 04.02.主题设置
                // 04.02.01.夜间主题设置
                night_theme_switch: false,
                // 04.02.02.切换主题设置
                automatic_theme_switch: false,
                // 04.02.03.折叠按钮设置
                side_button_switch: false,
                // 04.02.04.侧边栏手风琴设置
                side_accordion_switch: false,
                // 04.02.05.多页签设置
                tabs_multiple_switch: false,
                // 05.Form 配置/数据集 ------------------------------------------------
                // 05.01.Form基础信息
                // 05.01.01.Form配置 - 标题位置
                formPosition: 'left',
                // 05.01.02.Form配置 - 标题宽度
                formWidth: '200px',
                // 05.01.03.Form数据集
                formContent: {
                    title: '',
                    user_name: '',
                    phone: '',
                    mail: '',
                    content: '',
                    avatar: ''
                },
                // 05.01.04.Form 验证
                formRules: {
                    title: [
                        {required: true, message: '请输入用户姓名', trigger: 'blur'}
                    ]
                },
                // 05.01.05.Form 用户头像
                avatarUpload: '',
                // 05.02.Form账户密码
                // 05.02.01.Form配置 - 标题位置
                passPosition: 'top',
                // 05.02.03.Form数据集
                passContent: {
                    used_pass_word: '',
                    new_pass_word: '',
                    repeat_pass_word: ''
                },
                // 05.02.04.Form 验证
                passRules: {
                    used_pass_word: [
                        {required: true, message: "请输入原始密码", trigger: 'blur'}
                    ],
                    new_pass_word: [
                        {required: true, validator: new_pass_verification, trigger: 'blur'}
                    ],
                    repeat_pass_word: [
                        {required: true, validator: repeat_pass_verification, trigger: 'blur'}
                    ]
                },
                // 05.02.05.Form 弹出框状态
                passDialog: false,
            };
        },
        // 监听属性
        computed: {},
        // 监控data中的数据变化
        watch: {},
        // 方法集合
        methods: {
            // 01.Form表单操作 ------------------------------------------------
            // 01.01.Form更新信息
            patchUserContent() {
                this.$refs['formContent'].validate((valid) => {
                    if (valid) {
                        this.$api.post('/api/patch/login-admin/', this.formContent).then((response) => {
                            this.$message.success(response)
                        })
                    }
                })
            },
            // 01.02.Form修改密码 - 确认提交
            patchPassWord() {
                this.$refs['passContent'].validate((valid) => {
                    if (valid) {
                        this.$api.post('/api/patch/admin-patch-password/', this.passContent).then((response) => {
                            this.$message.success(response)
                        })
                    }
                })
            },
            // 01.03.Form修改密码 - 重置
            resetPassWord(){
                this.$refs['passContent'].resetFields()
            },
            // 01.03.Form绑定手机
            // patchPhone() {},
            // 01.04.Form密保问题
            // patchSecretGuard() {},
            // 02.Get获取数据 ------------------------------------------------
            // 02.01.获取用户信息
            getUserContent() {
                this.$api.get('/api/get/login-admin/').then((response) => {
                    if(response.data[0].avatar){
                        this.avatarUpload = this.$api_url + '/static/upload' + response.data[0].avatar
                    }
                    this.formContent.avatar = response.data[0].avatar
                    this.formContent.title = response.data[0].title
                    this.formContent.phone = response.data[0].phone
                    this.formContent.mail = response.data[0].mail
                    this.formContent.user_name = response.data[0].user_name
                    this.formContent.content = response.data[0].content
                })
            },
            // 02.02.获取消息通知状态
            getNewsState() {
                this.$api.get('/api/get/login-config/').then((response) => {
                    this.system_state_switch = response.data[0].notice
                    this.approval_state_switch = response.data[0].approval
                    this.im_state_switch = response.data[0].im
                    this.message_state_switch = response.data[0].message
                    this.mail_state_switch = response.data[0].mail
                })
            },
            // 02.03.获取主题设置状态
            getThemeState() {
                this.$api.get('/api/get/login-theme/').then((response) => {
                    this.night_theme_switch = response.data[0].theme
                    this.automatic_theme_switch = response.data[0].switch
                    this.side_button_switch = response.data[0].fold
                    this.side_accordion_switch = response.data[0].collapse
                    this.tabs_multiple_switch = response.data[0].tabs
                })
            },
            // 03.Switch系统设置 ------------------------------------------------
            // 03.01.消息通知
            // 03.01.01.系统通知
            changeSystemState($event) {
                this.$api.post('/api/patch/config/', {'state': $event, 'type': 'system'}).then((response) => {
                    this.$message.success(response)
                })
            },
            // 03.01.02.审批通知
            changeApprovalState($event) {
                this.$api.post('/api/patch/config/', {'state': $event, 'type': 'approval'}).then((response) => {
                    this.$message.success(response)
                })
            },
            // 03.01.03.IM消息
            changeImState($event) {
                this.$api.post('/api/patch/config/', {'state': $event, 'type': 'im'}).then((response) => {
                    this.$message.success(response)
                })
            },
            // 03.01.04.短信设置
            changeMessageState($event) {
                this.$api.post('/api/patch/config/', {'state': $event, 'type': 'message'}).then((response) => {
                    this.$message.success(response)
                })
            },
            // 03.01.05.邮件设置
            changeMailState($event) {
                this.$api.post('/api/patch/config/', {'state': $event, 'type': 'mail'}).then((response) => {
                    this.$message.success(response)
                })
            },
            // 03.02.主题设置
            // 03.02.01.夜间主题设置
            changeThemeSwitch($event) {
                this.$api.post('/api/patch/theme/', {'state': $event, 'type': 'theme'}).then((response) => {
                    this.$message.success(response)
                })
            },
            // 03.02.02.切换主题设置
            changeAutomaticTheme($event) {
                this.$api.post('/api/patch/theme/', {'state': $event, 'type': 'switch'}).then((response) => {
                    this.$message.success(response)
                })
            },
            // 03.02.03.折叠按钮设置
            changeCollapseBtn($event) {
                this.$api.post('/api/patch/theme/', {'state': $event, 'type': 'fold'}).then((response) => {
                    this.$message.success(response)
                })
            },
            // 03.02.04.侧边栏手风琴设置
            changeSideOpened($event) {
                this.$api.post('/api/patch/theme/', {'state': $event, 'type': 'collapse'}).then((response) => {
                    this.$message.success(response)
                })
            },
            // 03.02.05.多页签设置
            changeTabsState($event) {
                this.$api.post('/api/patch/theme/', {'state': $event, 'type': 'tabs'}).then((response) => {
                    this.$message.success(response)
                })
            },

            // 04.Avatar头像上传 ------------------------------------------------
            // 04.01.头像上传
            handleAvatarSuccess(res, file) {
                this.formContent.avatar = res.data
                this.avatarUpload = URL.createObjectURL(file.raw)
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type
                const isLt2M = file.size / 1024 / 1024 < 2
                if (isJPG !== 'image/jpeg') {
                    if (isJPG !== 'image/png') {
                        this.$message.error('上传头像图片类型只能是 jpg、png格式')
                    }
                } else {
                    if (!isLt2M) {
                        this.$message.error('上传头像图片大小不能超过 2Mb')
                    }
                }
                return isJPG && isLt2M
            },
        },
        // 生命周期 - 创建之前
        beforeCreate() {
        },
        // 生命周期 - 创建完成
        created() {
        },
        // 生命周期 - 挂载之前
        beforeMount() {
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 02.01.获取用户信息
            this.getUserContent()
            // 02.02.获取消息通知状态
            this.getNewsState()
            // 02.03.获取主题设置状态
            this.getThemeState()
        },
        // 生命周期 - 更新之前
        beforeUpdate() {
        },
        // 生命周期 - 更新之后
        updated() {
        },
    }
</script>
